/* eslint-disable new-cap */
/*
 * @Author: liangliang
 * @Date: 2023-06-02 11:37:56
 * @LastEditors: shiguang
 * @LastEditTime: 2024-04-25 18:00:41
 * @Description: 悬浮右侧菜单
 */
import React, { memo, useCallback, useEffect, useState, Suspense } from 'react';
import './index.scss';
import { Drawer } from 'antd';
import { useAtom } from 'jotai';
import { useMount } from 'ahooks';
import { CDN_HOST } from '@/const/staticURL';
import { CustomerDetail } from '@/model';
import { atomRequestCustomerDetail } from '@/App';
import { getCountryByNavigatorLang } from '@/const';
// import { jumpPage } from '@/utils';
// import { ENUM_PAGE } from '@/const/enum';
// import CalculatorPlugin from '../../container/utility/Calculator/Plugin';
// let channelFn = null;
const FloatToolbar = () => {
    const [isExpand, setIsExpand] = useState(true);
    const [msgCount, setMsgCount] = useState<number>(0);
    // const [showCalculator, setShowCalculator] = useState(false);
    // const [haveChannel, setHaveChannel] = useState(false);
    const [useInfo] = useAtom(CustomerDetail);
    const [customerDetail] = useAtom(atomRequestCustomerDetail);
    // 获取站点信息
    const stationCode =
        customerDetail?.stationCode || getCountryByNavigatorLang();

    const showEchart = () => {
        let language = '';
        if (customerDetail?.isJA) {
            language = 'ja';
        } else if (customerDetail?.isKO) {
            language = 'ko';
        } else {
            language = 'en';
        }
        const metaData = customerDetail?.customerId
            ? window.WECHAT.wxEncrypt(
                  '<xml>' +
                      '<uid><![CDATA[' +
                      customerDetail.customerId +
                      ']]></uid>' +
                      '<vip><![CDATA[' +
                      ((customerDetail?.membership?.templateLevel ?? 0) > 0
                          ? 1
                          : 2) +
                      ']]></vip>' +
                      '<category><![CDATA[' +
                      customerDetail.membership?.membershipTemplateName +
                      ']]></category>' +
                      '<name><![CDATA[' +
                      customerDetail.loginName +
                      ']]></name>' +
                      '<email><![CDATA[' +
                      customerDetail.customerEmail +
                      ']]></email>' +
                      '</xml>',
                  'M2Y2ZGZjOTkyMWIyNGYzNjlhOTNmZGU3M2E1ZGE4YWM',
                  '117081BF84079DE8244D1368AE578F9D'
              ).toString()
            : '';
        const customMiniChatData = {
            companyId: 533043,
            lan: language,
            echatTag: `web_${language}`,
            metaData
        };
        console.log(customMiniChatData, 'customMiniChat');
        window.ECHAT.customMiniChat(customMiniChatData);
    };

    useEffect(() => {
        const timer = setInterval(() => {
            if (window?._echat) {
                clearInterval(timer);
                window?._echat('on', {
                    // 一洽配置加载完成
                    ready: function () {},
                    // 一洽新消息数量
                    newMsg: function (num: number) {
                        setMsgCount(num);
                    }
                });
            }
        }, 1000);
        return () => clearInterval(timer);
    }, []);

    return (
        <aside className={`m-tool-bar ${isExpand ? 'tool-bar-show' : ''}`}>
            <ul>
                <li className="tool-bar-helpCenter">
                    <a className={isExpand ? 'bg-white' : ''}>
                        <img
                            draggable="false"
                            src={`${CDN_HOST}/BusinessMarket/icon/icon_help%402x.png`}
                            onClick={() => {
                                const config = {
                                    JapanStation: 'ja',
                                    KoreaStation: 'ko',
                                    UkStation: 'en'
                                };
                                if (
                                    window.location.host === 'pre-s.theckb.com'
                                ) {
                                    window.location.href = `https://pre-help.theckb.com/${config[stationCode]}`;
                                    return;
                                }
                                if (window.location.host === 's.theckb.com') {
                                    window.location.href = `https://help.theckb.com/${config[stationCode]}`;
                                    return;
                                }
                                window.location.href = `https://test-client-help.theckb.com/${config[stationCode]}`;
                            }}
                            alt=""
                        />

                        <span>{window._$m.t('帮助')}</span>
                    </a>
                </li>
                <li className="tool-bar-service">
                    <a
                        className={isExpand ? 'bg-white' : ''}
                        onClick={() => showEchart()}
                    >
                        <img
                            referrerPolicy="no-referrer"
                            draggable="false"
                            src={`${CDN_HOST}/BusinessMarket/icon/icon_serve%402x.png`}
                            alt=""
                        />

                        <span>{window._$m.t('客服')}</span>
                        {msgCount ? (
                            <div className="msg-count">{msgCount} </div>
                        ) : null}
                    </a>
                </li>
                {useInfo?.isKO && (
                    <li className="tool-bar-line">
                        <a
                            target="_blank"
                            className={isExpand ? 'bg-white' : ''}
                            style={{
                                textDecoration: 'none'
                            }}
                            href="https://pf.kakao.com/_uzWxoxj"
                        >
                            <img
                                referrerPolicy="no-referrer"
                                draggable="false"
                                src={`${CDN_HOST}/BusinessMarket/icon/kakao_footer.png`}
                                alt=""
                            />

                            <span>Kakao</span>
                        </a>
                    </li>
                )}

                {useInfo?.isJA && (
                    <li className="tool-bar-line">
                        <a
                            target="_blank"
                            className={isExpand ? 'bg-white' : ''}
                            style={{
                                textDecoration: 'none'
                            }}
                            href="https://line.me/R/ti/p/@962puoaf?oat_content=url"
                        >
                            <img
                                referrerPolicy="no-referrer"
                                draggable="false"
                                src={`${CDN_HOST}/BusinessMarket/icon/line_logo@2x.png`}
                                alt=""
                            />

                            <span>LINE</span>
                        </a>
                    </li>
                )}

                <li className="tool-bar-menu">
                    {isExpand ? (
                        <img
                            className="tool-bar-icon-menu"
                            draggable="false"
                            src={`${CDN_HOST}/BusinessMarket/icon/icon_close%402x.png`}
                            alt=""
                            onClick={() => setIsExpand(false)}
                        />
                    ) : (
                        <img
                            className="tool-bar-icon-menu"
                            draggable="false"
                            src={`${CDN_HOST}/BusinessMarket/icon/icon_open%402x.png`}
                            alt=""
                            onClick={() => setIsExpand(true)}
                        />
                    )}
                </li>
            </ul>
            {/* <Drawer
        title={window._$m.t('成本计算器')}
        onClose={() => setShowCalculator(false)}
        open={showCalculator}
        width={1200}
        >
        <CalculatorPlugin />
        </Drawer> */}
        </aside>
    );
};
export default memo(FloatToolbar);
